<template>
<div class="window window-bg window-alert" :class="{'window-lock':btnClose==false}" status="false" @click.self.stop="onClose">
	<div class="body bgContent" windowAlign="center" :class="sizeClass">
		<div class="head">
			<button v-if="btnClose" class="close close-ico bgClose style-close tra-fast fSub hover-f-error" type="button" @click.stop="hide('cancel')"><Icon name="close" /></button>
			<div class="title dpIB">{{myTitle}}</div>
			<slot name="head"></slot>
		</div>
		<div class="content lh15" :scroll="scroll?'':null">
			<div><slot></slot></div>
			<!-- <slot name="equipment"></slot> -->
		</div>
		<div class="toolBar taR vaM_E" v-show="btnMode=='around'"><!--borderToken_E ml1x_E mr1x_E dpIB_E w7x_E-->
			<button v-if="btnCancel" class="bdSub hover-bg-highLight" :title="btnCancel.text||getLanguageStr('cmd85','取消')" @click.stop="hide('cancel')" type="button">{{btnCancel.text||getLanguageStr('cmd85','取消')}}</button>
			<!-- 
			<button class="functionBtn close" @click="getList(filterAdvTemp,'filterAdv')" :title="$t('cmd12',['确定'])">{{$t('cmd12',['确定'])}}</button> -->
			<slot name="btmBtn"></slot>
		</div>
		<div v-show="btnMode=='upDown'" class="upDown"><slot name="btmBtnUD"></slot></div>
	</div>
</div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'

let timer
export default {
	name: 'WindowForAlert',
	components: {},
	props: {
		title: {
			type: String,
			default: getLanguageStr('phrase623', '请注意')
		},
		size: {
			type: String,
			default: 's'
		},
		btnClose: {// 是否显示关闭按钮
			type: Boolean,
			default: true
		},
		btnCancel: {//取消按钮设置
			// type: Boolean,
			default:()=>({text:""})
		},
		btnMode:{
			type: String,
			default: 'around'
		},
		scroll:{//是否需要配备滚动条
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			sizeClass: '',
			myTitle: this.title
		}
	},
	watch:{
		title:function(){
			this.myTitle=this.title;
		}
	},
	methods: {
		getLanguageStr,
		show: function (option) {
			if (option) {
				if (option.title != undefined) this.myTitle = option.title
				else this.myTitle = this.title
			}
			lib.windowCtrl($(this.$el),'true',{
				end:option?option.end:null
			});
		},
		hide: function (fn = null) {
			if(fn=="cancel") this.$emit("Cancel");
			this.$emit('Close')
			lib.windowCtrl($(this.$el), 'false', {end: () => {
				if ($.type(fn)=="function") fn(this.$el);
				this.$emit('Closed');
			}})
		},
		onClose: function () {
			if (this.btnClose) {
				this.hide("cancel");
				// setTimeout(() => {
				// 	if ($(this.$el).attr('status') == 'false') this.$emit('Close')
				// }, 0)
			}
		}
	},
	mounted () {
		switch (this.size) {
			case 'xs':this.sizeClass = 'body-xs'; break;
			case 's':this.sizeClass = 'body-s'; break;
			case 'm':this.sizeClass = 'body-m'; break;
			case 'l':this.sizeClass = 'body-l'; break;
		}
		let $this=this;
		$(this.$el).on("click",".toolBar .close",function(e){//close class的dom设置关闭窗口
			e.stopPropagation();
			$this.hide();
    });
    setTimeout(()=>{
      lib.setScroll($(this.$el).find('.content[scroll]'));
    },200)
		
		// this.$nextTick(()=>{//解决某些情况滚动无效
		// });
	}
}
</script>
<style lang="scss" scoped>
.window{
	&.window-alert{z-index:35;
		.style-close{margin:{top:-1em;};right:1em;}
	}
	// &[status="true"]{}
}
.upDown{
	display: flex;
	flex-direction:column;
	justify-content: center;
	padding: 1em 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/WindowForAlert.vue